import { useMemo } from "react";

import { Field, Label } from "V2.0/common/fieldset";
import { CheckboxGroup } from "V2.0/common/checkbox";

import SectionCheckboxField from "./SectionCheckboxField";

import { Tooltip } from "antd";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

import { ApplicationSection } from "V2.0/models/UserProfile";

export default ApplicationSectionsVisibility;

interface ApplicationSectionsVisibilityProps {
  visibleSections: Array<ApplicationSection>;
  onHideSection: (sectionName: ApplicationSection) => void;
  onUnhideSection: (sectionName: ApplicationSection) => void;
  disabled: boolean;
}

function ApplicationSectionsVisibility(
  props: ApplicationSectionsVisibilityProps,
) {
  const { visibleSections, onHideSection, onUnhideSection, disabled } = props;

  const applicationSections = useMemo(() => {
    return Object.keys(ApplicationSection).map((section) => {
      const sectionValue = ApplicationSection[section];
      return {
        name: sectionValue,
        label: section,
        isChecked: visibleSections.includes(sectionValue),
      };
    });
  }, [visibleSections]);

  const applicationSectionCheckboxFields = applicationSections.map(
    (section, idx) => {
      return (
        <SectionCheckboxField
          key={idx}
          isFirst={idx === 0}
          section={section}
          disabled={disabled}
          onHideSection={onHideSection}
          onUnhideSection={onUnhideSection}
        />
      );
    },
  );

  return (
    <Field disabled={disabled}>
      <Label className="flex items-center gap-x-2">
        Application Sections
        <Tooltip title="Applies only to Operator Role">
          <InformationCircleIcon className="size-4" />
        </Tooltip>
      </Label>
      <CheckboxGroup className="grid grid-cols-2 rounded-lg px-4 pt-2 py-4 space-y-4 space-x-2 border">
        {applicationSectionCheckboxFields}
      </CheckboxGroup>
    </Field>
  );
}
